import React from 'react'
import MarketInstrumentPage from './MarketInstrumentPage'

export default function PreciousMetals() {
  return (
    <MarketInstrumentPage
      activeMarket="Precious Metals"
      heroSymbol="Au"
      name="Precious Metals"
      tagline="Trade gold and silver with competitive spreads and flexible leverage."
      heroImageLabel="gold and silver bars background"
      descriptionImageLabel="trader viewing metals charts on laptop and mobile"
      description={{
        title: 'About Precious Metals Trading',
        paragraphs: [
          'Gold and silver have traded as stores of value for centuries, and today they remain popular instruments for traders looking to diversify away from currencies and equities.',
          'Through CFDs, Xperia Capital gives you direct price exposure to precious metals without needing to buy, store, or insure the physical asset — with leverage available to scale your position size.',
        ],
      }}
      conditions={[
        { symbol: 'XAU/USD', desc: 'Gold vs US Dollar', minSpread: { STD: '0.30', ECN: '0.05', PRO: '0.02' }, avgSpread: { STD: '0.35', ECN: '0.08', PRO: '0.05' }, pipValue: '10.00', minMove: '0.01', contractValue: '100 oz' },
        { symbol: 'XAG/USD', desc: 'Silver vs US Dollar', minSpread: { STD: '0.03', ECN: '0.01', PRO: '0.005' }, avgSpread: { STD: '0.04', ECN: '0.015', PRO: '0.01' }, pipValue: '5.00', minMove: '0.001', contractValue: '5,000 oz' },
      ]}
      whyTrade={[
        { icon: 'shield', title: 'Portfolio Hedge', desc: 'Metals often move independently of equities and currencies.' },
        { icon: 'trendUp', title: 'Leverage Available', desc: 'Scale exposure without tying up full capital in the physical asset.' },
        { icon: 'droplet', title: 'Deep Liquidity', desc: 'Gold and silver are among the most actively traded commodities globally.' },
        { icon: 'network', title: 'Trade Both Directions', desc: 'Go long or short depending on your market view.' },
      ]}
      faqs={[
        { q: 'What are precious metals CFDs?', a: 'A CFD (Contract for Difference) lets you speculate on the price movement of gold or silver without owning the physical metal — you profit or lose based on the price difference between opening and closing your position.' },
        { q: 'Why do traders invest in gold and silver?', a: 'Metals are often used as a hedge against inflation and currency weakness, and can behave differently from stocks and bonds during periods of market stress.' },
        { q: 'What moves precious metals prices?', a: 'Interest rate expectations, US dollar strength, inflation data, and broader risk sentiment are among the biggest drivers.' },
        { q: 'What is the minimum trade size for metals?', a: 'Minimum trade sizes vary by account type — check the trading conditions table above for current contract specifications.' },
      ]}
    />
  )
}
